angular.module('picmonicng').directive('commentNew', [
  function () {
    return {
      restrict: 'E',
      scope: {
        parent: '=',
      },
      controller: [
        '$scope',
        'CommentsResource',
        function ($scope, CommentsResource) {
          $scope.slug = $scope.$parent.slug;
          $scope.comments = $scope.$parent.comments;

          $scope.submitCommment = function () {
            if (!$scope.loading && $scope.newComment.comment) {
              $scope.loading = true;
              CommentsResource.save($scope.newComment).$promise.then(
                function (comment) {
                  $scope.comments.push(comment);
                  $scope.createNewComment();
                  if ($scope.parent) {
                    $scope.parent.showReply = false;
                  }
                  $scope.loading = false;
                },
                function () {
                  $scope.loading = false;
                }
              );
            }
          };

          $scope.createNewComment = function () {
            $scope.newComment = {
              slug: $scope.slug,
            };

            if ($scope.parent) {
              $scope.newComment.parent_id = $scope.parent.comment_id;
            }
          };

          $scope.createNewComment();
        },
      ],
      templateUrl: '/templates/directives/comment-new.html',
    };
  },
]);
